<template>
  <b-row>
    <b-col sm="12" lg="12">
      <marquee-text
        ref="floatingText"
        :duration="30"
        :repeat="1"
        style="padding-bottom: 5px"
      >
        <b-badge variant="info">Info</b-badge>
        {{ this.portalMsg }}
        <b-badge variant="info">Info</b-badge>
      </marquee-text>
    </b-col>

    <RegionOverview :lgSize="12"></RegionOverview>

    <ActiveBacklog
      v-if="!details"
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      @detailView="switchView"
    ></ActiveBacklog>
    <ActiveBacklog2
      v-else
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      :details="1"
      @detailView="switchView"
    ></ActiveBacklog2>

    <DeliveredEquipment
      ref="shipLine"
      v-if="!detailsShip"
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      @detailViewShip="switchViewShip"
    ></DeliveredEquipment>
    <DeliveredEquipment2
      v-else
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      :details="1"
      @detailViewShip="switchViewShip"
    ></DeliveredEquipment2>

    <RepairAnalytics
      v-if="!detailsRepair"
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      @detailViewRepair="switchViewRepair"
    ></RepairAnalytics>
    <RepairAnalytics2
      v-else
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      :details="1"
      @detailViewRepair="switchViewRepair"
    ></RepairAnalytics2>

    <HistoricalData
      v-if="!detailsHistorical"
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      @detailViewHistorical="switchViewHistorical"
    ></HistoricalData>
    <HistoricalData2
      v-else
      :lgSize="6"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      :details="1"
      @detailViewHistorical="switchViewHistorical"
    ></HistoricalData2>
  </b-row>
</template>

<script>
import ActiveBacklog from "../../../components/dashboard/active-backlog/ActiveBacklogColumn.vue";
import ActiveBacklog2 from "../../../components/dashboard/active-backlog/ActiveBacklogStacked";

import DeliveredEquipment from "../../../components/dashboard/delivered-equipment/DeliveredEquipmentColumn.vue";
import DeliveredEquipment2 from "../../../components/dashboard/delivered-equipment/DeliveredEquipmentStacked";

import RepairAnalytics from "../../../components/dashboard/repair-analytics/RepairAnalyticsLine";
import RepairAnalytics2 from "../../../components/dashboard/repair-analytics/RepairAnalyticsStacked";

import HistoricalData from "../../../components/dashboard/historical-data/HistoricalDataLine.vue";
import HistoricalData2 from "../../../components/dashboard/historical-data/HistoricalDataStacked";

import MarqueeText from "vue-marquee-text-component";
import RegionOverview from "../../../components/dashboard/region-overview/RegionOverview.vue";
export default {
  name: "Dashboard",
  components: {
    MarqueeText,
    ActiveBacklog,
    ActiveBacklog2,
    DeliveredEquipment,
    DeliveredEquipment2,
    RepairAnalytics,
    RepairAnalytics2,
    HistoricalData,
    HistoricalData2,
    RegionOverview
  },
  data: function() {
    return {
      details: false,
      detailsShip: false,
      detailsRepair: false,
      detailsHistorical: false,
      portalMsg: ""
    };
  },
  methods: {
    fetchMessage() {
      this.$http.get("api/auth/portalMsg.php").then(
        res => {
          this.portalMsg = res.data.text;
        },
        err => {
          console.log(err);
        }
      );
    },
    switchView() {
      this.details = !this.details;
    },
    switchViewShip() {
      this.detailsShip = !this.detailsShip;
    },
    switchViewRepair() {
      this.detailsRepair = !this.detailsRepair;
    },
    switchViewHistorical() {
      this.detailsHistorical = !this.detailsHistorical;
    }
  },
  mounted() {
    this.fetchMessage();
  }
};
</script>

<style>
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.highcharts-label {
  color: #00bf8f !important;
  fill: #00bf8f !important;
}
.power {
  background-color: #f86c6b !important;
}
.marquee-text-content {
  width: 100%;
}
.marquee-text-text {
  margin-bottom: 6px;
  margin-top: -4px;
  display: inline-block;
  overflow: hidden;
  text-align: initial;
  white-space: nowrap;
  width: 100%;
  text-align: right;
  animation-iteration-count: 1 !important;
  animation-delay: 5s;
}
</style>
